import React, { useEffect, useState } from "react";
import { TypeAnimation } from "react-type-animation";
import ServiceCard from "../ServiceCard/ServiceCard";
import { ScaleLoader } from "react-spinners";
import "./Services.css";

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch("https://food-for-you-server.vercel.app/services")
      .then((res) => res.json())
      .then((data) => {
        setServices(data);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <section className="services-section mb-5">
        <div className="mx-auto w-discover">
          <h2
            className="text-center fw-semibold mb-3 fs-2"
            data-aos="fade-down"
            data-aos-duration="2000"
          >
            <TypeAnimation
              sequence={["My Delivery Services", 3000]}
              speed={40}
              cursor={false}
              repeat={Infinity}
            />
          </h2>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
            <ScaleLoader color="#007b96" height="18" speedMultiplier=".6" />
            <span className="fw-semibold fs-my-10 text-danger">
              Wait! Data is loading..
            </span>
          </div>
        ) : (
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 service-card mt-3">
            {services.map((service) => (
              <ServiceCard key={service._id} service={service}></ServiceCard>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Services;
